export default __webpack_public_path__ + "static/media/kompetensvy_black.5e59571a.png";